import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { MockStoreLinks } from '__mocks__';
import { InstoreCategoryCard } from 'common/components';
import { getInstoreCategoryData } from 'utils';
import { selectCategories, selectSelectedStoreCode } from '../../../selectors';
import { StyledDiv } from './styles';

export const CardsContainer = () => {
	const categories = useSelector(selectCategories);
	const selectedStoreCode = useSelector(selectSelectedStoreCode);

	const storeLink = useMemo(() => {
		return selectedStoreCode
			? MockStoreLinks.find(({ code }) => code === selectedStoreCode)?.link || null
			: null;
	}, [selectedStoreCode]);

	return (
		<StyledDiv>
			{categories.map(category => {
				const cardData = getInstoreCategoryData(category, storeLink);

				return <InstoreCategoryCard key={`card-${category.name}`} {...cardData} />;
			})}
		</StyledDiv>
	);
};
